<template>
  <div class="atributos-container">
    <h2 class="atributos-title">Detalhes do Imóvel</h2>
      <v-row dense>
        <v-col
          v-for="(atributo, index) in atributos"
          :key="index"
          cols="12"
          md="6"
          lg="3"
          class="atributo-item"
        >
          <v-icon class="atributo-icon" :size="32" color="primary">{{ atributo.icone }}</v-icon>
          <span class="atributo-text">{{ atributo.texto }}</span>
        </v-col>
      </v-row>
  </div>
</template>

<script>
export default {
  name: "AtributosImovelComponent",
  props: {
    atributos: {
      type: Array,
      required: true,
      default: () => [
        { icone: "mdi-home", texto: "4 dormitórios sendo 1 suíte" },
        { icone: "mdi-car", texto: "3 vagas na garagem coberta, 1 vaga na garagem aberta" },
        { icone: "mdi-sofa", texto: "1 sala de estar" },
        { icone: "mdi-shower", texto: "3 banheiros e 1 lavabo" },
        { icone: "mdi-wash", texto: "1 espaço para lavanderia" },
        { icone: "mdi-baby", texto: "1 quartinho" },
        { icone: "mdi-food", texto: "1 cozinha ampla e churrasqueira" },
      ],
    },
  },
};
</script>

<style scoped>
.atributos-container {
  width: 100%;
  margin: 2rem auto;
  padding: 0;
  max-width: 1400px;
}

.atributos-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 2rem;
  color: var(--v-primary-base);
  padding: 0 1rem;
  text-align: left;
  letter-spacing: -0.5px;
  line-height: 1.2;
}

.atributo-item {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  padding: 0 1rem;
  justify-content: flex-start;
}

.atributo-icon {
  margin-right: 1.25rem;
}

.atributo-text {
  font-size: 1.1rem;
  color: var(--v-secondary-base);
  font-weight: 500;
  text-align: left;
  letter-spacing: 0.25px;
  line-height: 1.5;
}

@media (max-width: 600px) {
  .atributos-container {
    margin: 1.5rem auto;
  }

  .atributos-title {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .atributo-text {
    font-size: 1rem;
  }
}
</style>